module.exports = __webpack_public_path__ + "static/media/ant-internet.847ae4d4.png";